import React from "react";
import ReimbursementTransactionsViewAll from "../../containers/Transactions/ReimbursementTransactions/ReimbursementTransactionViewAll";
import LargePopupRedirect from "../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../assets/Icons";

const ReimbursementTxnViewAllPopup = ({
  closeReimburseTxnDetailsModal,
  TxnHistoryid,
  TxnHistoryAccountName,
  categoryName,
  type,
  HistoryPopup,
  flow,
  txnLabelfilter,
  popupCatName,
}) => {
  return (
    <div>
      <LargePopupRedirect
        headerTitle={
          flow === "txnLabelfilterhistory"
            ? "Transactions sharing the same label"
            : "Transaction history"
        }
        headersubtext={
          flow === "txnLabelfilterhistory"
            ? `All transactions related to ${txnLabelfilter} are listed below.`
            : "All transactions related to the reimbursement are listed below."
        }
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={() => closeReimburseTxnDetailsModal()}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
      >
        <ReimbursementTransactionsViewAll
          type={type}
          TxnHistoryid={TxnHistoryid}
          TxnHistoryAccountName={TxnHistoryAccountName}
          categoryName={categoryName}
          txnLabelfilter={txnLabelfilter}
          closeReimburseTxnDetailsModal={closeReimburseTxnDetailsModal}
          HistoryPopup={HistoryPopup}
          flow={flow}
          popupCatName={popupCatName}
        />
      </LargePopupRedirect>
    </div>
  );
};

export default ReimbursementTxnViewAllPopup;
